import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgPipesModule } from 'ngx-pipes';

import { environment } from '@app/env-service';
import { PartialsModule } from '@app/layout-sidebar/partials/partials.module';

import { NotificationDropoutComponent } from './notification-dropout/notification-dropout.component';
import { NotificationRoutingModule } from './notification-routing.module';
import { TopNotifComponent } from './top-notif/top-notif.component';

@NgModule({
  declarations: [TopNotifComponent, NotificationDropoutComponent],
  imports: [
    CommonModule,
    NotificationRoutingModule,
    PartialsModule,
    NgbModule,
    PerfectScrollbarModule,
    InlineSVGModule,
    NgPipesModule,
    TranslateModule.forChild(),
    RouterModule,
    MatTooltipModule,
  ],
  exports: [TopNotifComponent, NotificationDropoutComponent],
})
export class NotificationModule {}
